import coreApiService from './core.service';

const LIST = 'pv/article/list';
const LIST_CAROUSEL = 'pv/article/list-carousel';
const DETAIL = 'pv/article/slug';

export const articleApi = {
    list: (limit: number, offset: number) => coreApiService.get(LIST, { limit, offset }),
    listCarousel: (limit: number, offset: number) => coreApiService.get(LIST_CAROUSEL, { limit, offset }),
    detail: (slug: string) => coreApiService.get(`${DETAIL}/${slug}`),
};
